import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Main from './components/Main';
import PrivateRoute from './components/PrivateRoute';
import Login from './components/Login';
import Register from './components/Register';
import AdminDashboard from './components/admin-dashboard';
import OwnerDashboard from './components/owner-dashboard';
import EngDashboard from './components/engineer-dashboard';
import Projects from './components/Projects';
import SubprojectPage from './components/SubprojectPage';
import ProjectPage from './components/ProjectPage';
import SettingsPage from './components/SettingsPage';
import Sidebar from './components/Sidebar';
import CustomReportsPage from './components/CustomReportsPage';
import Deficiencies from './components/Deficiencies';
import Electrical from './components/ElectricalData';
import { AuthProvider } from './AuthContext';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<Login />} />
            <Route path="/register" element={<Register />} />

            {/* Protected routes */}
            <Route path="/admin-dashboard" element={
              <PrivateRoute><AdminDashboard /></PrivateRoute>
            } />
            <Route path="/owner-dashboard" element={
              <PrivateRoute><OwnerDashboard /></PrivateRoute>
            } />
            <Route path="/engineer-dashboard" element={
              <PrivateRoute><EngDashboard /></PrivateRoute>
            } />
            <Route path="/projects" element={
              <PrivateRoute><Projects /></PrivateRoute>
            } />
            <Route path="/projects/:projectId/subprojects/:subprojectId" element={
              <PrivateRoute><SubprojectPage /></PrivateRoute>
            } />
            <Route path="/project/:projectId" element={
              <PrivateRoute><ProjectPage /></PrivateRoute>
            } />
            <Route path="/settings" element={
              <PrivateRoute><SettingsPage /></PrivateRoute>
            } />
            <Route path="/custom-reports" element={
              <PrivateRoute><CustomReportsPage /></PrivateRoute>
            } />
            <Route path="/deficiencies" element={
              <PrivateRoute><Deficiencies /></PrivateRoute>
            } />
            <Route path="/electrical" element={
              <PrivateRoute><Electrical /></PrivateRoute>
            } />
          </Routes>

          <div className="footer-info-fixed">
            © 2025 Vilano Engineering LLC
          </div>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
